var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("span", { staticClass: "general-header" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.resource(
                    "TouchpointStatistics_Overview_Other_GeneralHeader"
                  )
                ) +
                "\n            "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.statistics
        ? _c("statistics-page", { attrs: { data: _vm.categories } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }